function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg width="12" height="13" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M233 0C104.317 0 0 97.005 0 216.667c0 68.185 33.882 129.004 86.832 168.721V468l79.335-43.728c21.172 5.885 43.602 9.061 66.833 9.061 128.683 0 233-97.004 233-216.666C466 97.005 361.683 0 233 0zm23.155 291.778l-59.335-63.556-115.776 63.556L208.397 156l60.782 63.556L383.509 156 256.155 291.778z" fill="#4B2118" /></svg>;
});